module.exports = __webpack_public_path__ + "static/img/9d30f83.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/xczx/img/banner.png
// module id = 699
// module chunks = 2